import { useState } from 'react';
import { PowerOff } from 'lucide-react';
import { api } from '@/shared/api/cliente';
import { ErrorDeApi } from '@/shared/api/problema';
import type { CuentaDeServicio } from '@/shared/api/tipos';
import { AccionesDelFormulario, Campo, Modal, claseEntrada } from '@/shared/ui/Modal';
import { notificar } from '@/shared/ui/avisos';

export function DialogoDeBajaDeCuenta({
  abierto,
  cuenta,
  alCerrar,
  alGuardar,
}: {
  abierto: boolean;
  cuenta: CuentaDeServicio | null;
  alCerrar: () => void;
  alGuardar: () => void;
}) {
  const [motivo, setMotivo] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  if (cuenta === null) {
    return null;
  }

  async function enviar(evento: React.FormEvent) {
    evento.preventDefault();
    if (cuenta === null) {
      return;
    }

    setError(null);
    setEnviando(true);
    try {
      await api.post<CuentaDeServicio>(`/cuentas/${cuenta.id}/desactivar`, { motivo });
      alGuardar();
      alCerrar();
      notificar.exito(`Cuenta ${cuenta.numeroCuenta} desactivada`);
    } catch (causa) {
      const mensaje =
        causa instanceof ErrorDeApi ? causa.message : 'No se pudo desactivar la cuenta';
      setError(mensaje);
      notificar.error(mensaje);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <Modal
      abierto={abierto}
      alCerrar={alCerrar}
      titulo="Desactivar cuenta"
      subtitulo={`Cuenta ${cuenta.numeroCuenta}`}
      icono={PowerOff}
      cerrarAlPulsarFuera={false}
    >
      <form onSubmit={enviar} className="space-y-4">
        {error && (
          <p
            role="alert"
            className="rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-900"
          >
            {error}
          </p>
        )}

        <p className="rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] uppercase leading-relaxed text-amber-900">
          Este predio deja de facturarse desde la siguiente emisión. Lo ya emitido no cambia: las
          facturas pendientes siguen debiéndose.
        </p>

        <Campo
          etiqueta="Motivo"
          requerido
          ayuda="QUEDA GUARDADO EN LA CUENTA Y SE VE AL CONSULTARLA"
        >
          <textarea
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            rows={3}
            maxLength={255}
            required
            autoFocus
            className={`${claseEntrada} resize-none`}
            placeholder="Predio demolido, servicio suspendido, error de registro…"
          />
        </Campo>

        <AccionesDelFormulario
          alCancelar={alCerrar}
          enviando={enviando}
          textoEnviar="Desactivar cuenta"
        />
      </form>
    </Modal>
  );
}
